<img src="https://padelyard-om.com/assets/t1.png"
     style="z-index: 0;position: absolute;
height: 100vh;image-orientation: contain, cover;width: fit-content;"
/>
<div class="center">

    <img src="https://padelyard-om.com/assets/logo.jpg"
    style="display: inline; width: 100px;margin: 20px auto;border-radius: 50px;z-index: 10">
    <!-- {{"common.search" | translate}} -->
    <!-- <div [translate]="'common.search'" ></div> -->
<div class="wrapper">

 
    <!-- <a href="{{linkList['twitter']}}">
        <div class="LinkIc" style="justify-content: flex-end">

            <span style="color: #a1a5b7;font-size: 20px;  ">
                twitter
            </span>
            <i class="fa-brands fa-twitter" style="font-size: 35px; justify-content: flex-end;"></i>
      
        </div>
    </a> -->

   
    <a href="{{linkList['booking']}}">
        <div class="LinkIc" style="justify-content: flex-end">
            <span style="color: #a1a5b7;font-size: 20px;  ">
                Booking
            </span>
            <i class="fa-solid fa-calendar-days" style="font-size: 35px; justify-content: flex-end;"></i>

        </div>
    </a>
    <a href="{{linkList['whatsapp']}}">
        <div class="LinkIc" style="justify-content: flex-end">
            <span style="color: #a1a5b7;font-size: 20px;  ">
                whatsapp
            </span>
            <i class="fa-brands fa-square-whatsapp" style="font-size: 35px; justify-content: flex-end;"></i>
  
        
        </div>
    </a>
    <a href="{{linkList['instagram']}}">
        <div class="LinkIc" style="justify-content: flex-end">
            <span style="color: #a1a5b7;font-size: 20px;  ">
                instagram
            </span>
            <i class="fa-brands fa-square-instagram" style="font-size: 35px; justify-content: flex-end;"></i>

   
       
        </div>
    </a>
    <a href="{{linkList['twitter']}}">
        <div class="LinkIc" style="justify-content: flex-end">

            <span style="color: #a1a5b7;font-size: 20px;  ">
                Google Map
            </span>
            <i class="fa-solid fa-map-location-dot"  style="font-size: 28px; justify-content: flex-end;"></i>
      
        </div>
    </a>
</div>
</div>
